export default "__VITE_ASSET__DcwX01ZO__"